import { render, staticRenderFns } from "./VistaMonitoreo.vue?vue&type=template&id=c401bbfa&"
import script from "./VistaMonitoreo.vue?vue&type=script&lang=ts&"
export * from "./VistaMonitoreo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports